module.exports = __webpack_public_path__ + "img/part2-right-bg.cf0c04cd.png";